import React from 'react';

import MainMenu from '../../_components/MainMenu';
import MainFooter from '../../_components/MainFooter';
import PreLoader from "../../_components/PreLoader";

import { menuService } from '../../_services/menu.service';
import { postService } from '../../_services/post.service';
import { emailService } from '../../_services/email.service';
import * as Yup from "yup";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt
} from "@fortawesome/free-solid-svg-icons";
import './Contact.sass';

class Contact extends React.Component {
    constructor(props) {
        super(props);
  
        this.state = {
            loading: true,
            user: {
                details: {}
            },
            menu: {},
            topbarMenu: {},
            settings: {},
            stores: {},
            branches: [],
            pages: {},
            mainOffice: {},
            serviceCenter: {},
            contactForm: {},
            contact: {
                name: '',
                email: '',
                phone: '',
                message: '',
                emailValid: false,
            },
            alert: null,
            submitting: false,
            errors: {}
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        const { contact } =  this.state;

        if(name === 'email'){
            contact.emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        }

        this.setState({contact: { 
            ...contact,
            [name]: value 
        }});
    }

    handleSubmit(e) {
        e.preventDefault();
        const { contact, submitting } = this.state;

        if (submitting) return;

        this.setState({ submitting: true, errors: {}, alert: null });

        const validationSchema = Yup.object().shape({
          name: Yup.string().required(),
          email: Yup.string().email().required(),
          phone: Yup.string().required(),
          message: Yup.string().required()
        });

        validationSchema
          .validate(contact, { abortEarly: false })
          .then(() => {
            // contact.message = 'Name: ' + contact.name + ',<br/></br>Email address: ' + contact.email + '<br/>Contact number: ' + contact.phone + '<br/><br />Message: ' + contact.message + '<br/><br/>'

            // contact.message = 'Name: ' + contact.name + ',<br/></br>Email address: ' + contact.email + '<br/>Contact number: ' + contact.phone + '<br/><br />Message: ' + contact.message + '<br/><br/>'
            
            //set email reciepient to be the contact from data
            // contact.email = settings['email-from'];

            emailService.send(contact).then((response) => {
                this.setState({ alert: { message: response.message, type: "success" }, submitting: false })
            }).catch((error) => {
                this.setState({ alert: { message: "Failed to send your message", type: "danger" }, submitting: false })
            });
          })
          .catch((yupError) => {
              const errors = yupError.inner.reduce(
                  (errors, err) =>
                    Object.assign(errors, {
                      [err.path]: err.errors[0],
                    }),
                  {}
                );

              this.setState({ submitting: false, errors });
          });

    }

    componentDidMount() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user && Date.now() < user.expiresAt) {
        this.setState({
            user: user
        });
        } else {
        this.setState({
            user: {
            details: {}
            }
        });
        }

        Promise.allSettled([
            postService.getBySlug('contact').then(pages => this.setState({ pages })),
            postService.getBySlug('service-center').then(serviceCenter => this.setState({ serviceCenter })),
            postService.getBySlug('contact-form').then(contactForm => this.setState({ contactForm })),
            postService.getParentId("branch-list").then(id => {
                postService.getChild(id).then(stores => { this.setState({ stores })})
            }),
            menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu })),
            menuService.getMenuByName('default').then(menu => this.setState({ menu })),
            postService.getBranchesFooter('branch').then(branches => this.setState({ branches })),
            // postService.getBySlug('branch').then(branches => this.setState({ branches })),
            
            // settingsService.getAll().then( settings => this.setState({settings})),

            // settingsService.getAll()
            //     .then( settings => branchService.getById(settings['main-office--manila'])
            //     .then( mainOffice => branchService.getById(settings['service-center'])
            //     .then( serviceCenter => this.setState({settings, mainOffice, serviceCenter }) ))),

            // menuService.getMenuByName().then(menu => this.setState({ menu })),
            // menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu })),
            // branchService.getAll(1, 10000).then(branches => this.setState({ branches })),
            
            // postService.getBySlug('contact-us').then(page => this.setState({ page })),
            // postService.getBySlug('send-a-message').then(contactForm => this.setState({ contactForm }))
        ]).then(() => this.setState({ loading: false }))
    }

    render() {
        const { loading, user, menu, topbarMenu, branches, pages, contactForm, alert, serviceCenter, stores } = this.state;
 
        return (
            <div>
                <PreLoader loading={loading} />
                <MainMenu user={user} menu={menu} topbarMenu={topbarMenu}/>
                
                <div className="jumbotron page-title py-5">
                    <div className="container"><h1 className="text-white">Contact Us</h1></div>
                </div>
                {pages && Array.isArray(pages) && pages.map((page, index) => 
                <React.Fragment key={index}>
                    <section>
                        <div className="container">
                            <div className="row mb-5">
                                <div className="col-12">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb bg-transparent m-0">
                                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                                            <li className="breadcrumb-item active" aria-current="page">{page.title.rendered}</li>
                                        </ol>
                                    </nav>
                                    <hr className="m-0 mb-4" />						
                                </div>
                                <div className="col-12">
                                    <h3 className="font-weight-lighter mb-5 line-height-md msg" dangerouslySetInnerHTML={{ __html: page.content.rendered }} />
                                    <hr className="mb-5" />
                                    <div className="row">
                                        <div className="col-12 col-md-5 col-lg-3">
                                            {/* { mainOffice &&
                                                <div className="card store-card-single store-card-special mb-5 p-3">
                                                    <div className="card-body p-0">
                                                        <h4 className="card-title pt-2">Main Office - Manila</h4>
                                            <p className="card-text"><strong>{mainOffice.name || ''}</strong> <br />{ mainOffice.address1 }, { mainOffice.address2 }, { mainOffice.state }, { mainOffice.country } <br /> <br />Phone: {mainOffice.phone || ''}<br /> Email: <a href={'mailto://'+mainOffice.email || ''}>{mainOffice.email || ''}</a><br /><span className="text-danger">{mainOffice.description || ''}</span></p>
                                                    </div>
                                                    <div className="card-footer p-0 pt-3">
                                                        <p className="card-text"><a href={`https://www.google.com/maps/?q=${mainOffice.address1} ${mainOffice.city} ${mainOffice.state} ${mainOffice.country}`}><FontAwesomeIcon icon={faMapMarkerAlt} /> View Map</a></p>
                                                    </div>
                                                </div>
                                            } */}
                                            { serviceCenter && Array.isArray(serviceCenter) && serviceCenter.map(({acf}, index) => 
                                                <div className="card store-card-single store-card-special p-3" key={index}>
                                                    <div className="card-body p-0">
                                                        <h4 className="card-title pt-2">Service Center</h4>
                                                        <p className="card-text"><strong>{acf.name || ''}</strong> <br />{ acf.address1 }, { acf.address2 }, { acf.state }, { acf.country }<br /> <br />Phone: {acf.phone || ''}<br /> Fax: { acf.fax || ''}</p>
                                                    </div>
                                                    <div className="card-footer p-0 pt-3">
                                                        <p className="card-text"><a href={`${acf.google_map}`}><FontAwesomeIcon icon={faMapMarkerAlt} /> View Map</a></p>
                                                    </div>
                                                </div>
                                            )}									
                                        </div>
                                        { contactForm && Array.isArray(contactForm) && contactForm.map(({acf}, index) => 
                                        <div className="col-12 col-md-7 col-lg-9 mt-3 mt-md-0" key={index}>
                                            <h3>{ acf.title || 'Title' }</h3>
                                            <p>{ acf.content || 'content' }</p>			
                                            {alert &&
                                                <div className={`alert alert-${alert.type}`} role="alert">
                                                    {alert?.message}
                                                </div>	
                                            }								
                                            <form>
                                                <div className="form-row">
                                                    <div className="form-group col-lg-4">
                                                        <label htmlFor="">Full Name</label>
                                                        <input name="name" type="text" className={`form-control ${this.state.errors.name && "is-invalid"}`} onChange={this.handleChange}/>
                                                        { this.state.errors.name &&
                                                            <small className="text-danger">{ this.state.errors.name || 'Name is required.' }</small>
                                                        }
                                                    </div>
                                                    <div className="form-group col-lg-4">
                                                        <label htmlFor="">Email</label>
                                                        <input name="email" type="text" className={`form-control ${this.state.errors.email && "is-invalid"}`} onChange={this.handleChange}/>
                                                        { this.state.errors.email &&
                                                            <small className="text-danger">{ this.state.errors.email || 'Email is required.' }</small>
                                                        }
                                                    </div>
                                                    <div className="form-group col-lg-4">
                                                        <label htmlFor="">Phone Number</label>
                                                        <input name="phone" type="text" className={`form-control ${this.state.errors.phone && "is-invalid"}`} onChange={this.handleChange}/>
                                                        { this.state.errors.phone &&
                                                            <small className="text-danger">{ this.state.errors.phone || 'Phone Number is required.' }</small>
                                                        }
                                                    </div>											
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group col-lg-12">
                                                        <label htmlFor="">Message</label>
                                                        <textarea name="message" id="" cols="30" rows="10" className={`form-control ${this.state.errors.message && "is-invalid"}`} onChange={this.handleChange}></textarea>
                                                        { this.state.errors.message &&
                                                            <small className="text-danger">{ this.state.errors.message || 'Message is required.' }</small>
                                                        }
                                                    </div>											
                                                </div>
                                                <div className="form-row">
                                                    <div className="col-lg-12">
                                                        <button className="btn btn-primary btn-lg" onClick={this.handleSubmit}>Send Message</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        )}								
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="top-store py-5">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <h2 className="mb-3">Stores:</h2>
                                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4">
                                        { stores && Array.isArray(stores) && stores.sort((a,b) => { return a.menu_order - b.menu_order}).map(({acf}, index) => 
                                            <div className="col mb-3" key={index}>
                                                <div className="card store-card-single">
                                                    <div className="card-body p-0">
                                                        <h4 className="card-title pt-2">{acf.city}</h4>
                                                        <p className="card-text"><strong>{acf.name}</strong> <br />{acf.address1}, {acf.address2}, {acf.city}, {acf.state}, {acf.country} <br /> <br />
                                                        
                                                        {acf.phone && 
                                                        <>
                                                        <span>Phone: </span>
                                                        {acf.phone.split(',').map((phone, index)=>
                                                            <span key={index}><a href={'callto://'+phone}>{phone}</a>{acf.phone.split(',').length -1 === index ? '': ','}&nbsp;</span>
                                                        )}
                                                        </>
                                                        }<br />
                                                        {acf.fax &&
                                                            <span>Fax: <a href={'callto://'+acf.fax}>{acf.fax}</a></span>
                                                        }
                                                        </p>
                                                        
                                                    <p><span className="text-danger">{acf.description}</span></p>
                                                    </div>
                                                    <div className="card-footer p-0 pt-2">
                                                        {acf.address1 && acf.city && acf.state && acf.country &&
                                                                <p className="card-text">
                                                                    <a href={`${acf.google_map}`}> 
                                                                    <FontAwesomeIcon icon={faMapMarkerAlt} /> View Map
                                                                    </a> 
                                                                </p>
                                                            }
                                                    </div>
                                                </div>
                                            </div>
                                        )}																																						
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <MainFooter menu={menu} branches={branches} />
                </React.Fragment>
            )}

            </div>
            
        )
    }
}

export { Contact }
